<template>
<div class="chapter">
<div class="inner_page">
<h1>The French Cook</h1>
<div class="toc">
<p>
<b>Table of Contents</b>
</p>
<dl>
<dt>
<span class="chapter">
<a href="#/ch01">Introduction</a>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch02" title="Link target outside of Sample">The Art of Making Choux Pastry </span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch03" title="Link target outside of Sample">Equipment for Preparing Choux Pastry </span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch04" title="Link target outside of Sample">Savory Cream Puffs and Choux Rings </span>
</span>
</dt>
<dd>
<dl>
<dt>
<span class="bridgehead">
<span href="#/ch04#mastersavorycream" title="Link target outside of Sample">Recette Maîtresse pour la Pâte à Choux
                  Savoureux </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch04#d0e405" title="Link target outside of Sample">Master Recipe for Savory Cream Puffs
                  (for preparing savory choux puffs, éclairs and rings) </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e449" title="Link target outside of Sample">“Soupe” à l’Oignon aux Petits Choux de Gruyère Fondu </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch04#d0e451" title="Link target outside of Sample">French Onion "Soup" with Melted Gruyère Cheese in Savory
                  Cream Puffs </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e516" title="Link target outside of Sample">Petits Choux aux Epinards Crémeux et Croquants </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch04#d0e518" title="Link target outside of Sample">Small Savory Cream Puffs with Crunchy Creamed Spinach
                </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e576" title="Link target outside of Sample">Gougères aux Trois Fromages et au Poivre </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch04#d0e578" title="Link target outside of Sample">Cheese Puffs with Three Cheeses and Pepper </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e618" title="Link target outside of Sample">Petits Pots de Fruits de Mer aux Choux </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch04#d0e620" title="Link target outside of Sample">Seafood Pot Pies </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e689" title="Link target outside of Sample">Gnocchi de Pâte à Choux aux Fines Herbes, Sauce
                  d'Echalotes et de Safran au Beurre </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch04#d0e691" title="Link target outside of Sample">Herbed Savory Cream Puff Gnocchi with a Shallot and
                  Saffron Butter Sauce </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e748" title="Link target outside of Sample">Gnocchi de Pâte à Choux Gratinés </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch04#d0e750" title="Link target outside of Sample">Gratin of Savory Choux Gnocchi </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e759" title="Link target outside of Sample">Petites Choux au Saumon Fumé et aux Concombres </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch04#d0e761" title="Link target outside of Sample">Small Savory Cream Puffs with Smoked Salmon and Cucumbers
                </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e808" title="Link target outside of Sample">Petits Choux à la Chèvre, au Miel et à la Purée de l’Ail
                  Cuit au Four </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch04#d0e810" title="Link target outside of Sample">Small Savory Cream Puffs with Goat Cheese, Honey and
                  Roasted Garlic Purée </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e868" title="Link target outside of Sample">Sandwiches de Petits Choux à la Salade d’Endives, Pommes
                  et Noix au Roquefort </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch04#d0e870" title="Link target outside of Sample">Small Savory Cream Puff Sandwiches of Endive, Apple,
                  Walnut and Roquefort Salad </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e921" title="Link target outside of Sample">Sandwichs de Choux à la Salade de Crevettes </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch04#d0e923" title="Link target outside of Sample">Savory Cream Puff Sandwiches of Shrimp Salad </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e971" title="Link target outside of Sample">Croques Messieurs aux Petits Choux </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch04#d0e973" title="Link target outside of Sample">Small Savory Ham and Cheese Cream Puffs </span>
</span>
</dt>
</dl>
</dd>
<dt>
<span class="chapter">
<span href="#/ch05" title="Link target outside of Sample">Savory Éclairs and Choux Rings </span>
</span>
</dt>
<dd>
<dl>
<dt>
<span class="bridgehead">
<span href="#/ch05#avocado" title="Link target outside of Sample">Petits Éclairs à la Mousse d’Avocat au Bacon et aux
                  Tomates </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch05#d0e1039" title="Link target outside of Sample">Small Éclairs with Avocado Mousse, Bacon and Tomatoes
                </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch05#d0e1100" title="Link target outside of Sample">Petits Éclairs à la Salade de Caesar au Beurre d’Anchois
                </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch05#d0e1102" title="Link target outside of Sample">Small Éclairs Caesar Salad–Style with Anchovy Butter
                </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch05#d0e1158" title="Link target outside of Sample">Salade Niçoise Composée dans und Gros Rond de Pâte à
                  Choux </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch05#d0e1160" title="Link target outside of Sample">Composed Niçois Salad in a Large Savory Choux Ring </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch05#d0e1223" title="Link target outside of Sample">Pâté de Foies de Volailles aux Pruneaux sur les Petits
                  Ronds de Pâte à Choux </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch05#d0e1225" title="Link target outside of Sample">Chicken Liver Pâté with Prunes on Small Savory Choux
                  Rings </span>
</span>
</dt>
</dl>
</dd>
<dt>
<span class="chapter">
<span href="#/ch06" title="Link target outside of Sample">Sweet Cream Puffs, Choux Rings, and Variations</span>
</span>
</dt>
<dd>
<dl>
<dt>
<span class="bridgehead">
<span href="#/ch06#d0e1304" title="Link target outside of Sample">Recette Maîtresse pour la Pâte à Choux Sucrée </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch06#masterrecipechoux" title="Link target outside of Sample">Master Recipe for Sweet Choux Pastry (for
                  preparing sweet choux puffs, éclairs and rings) </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch06#d0e1352" title="Link target outside of Sample">Choux à la Crème de Noix de Coco </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch06#d0e1354" title="Link target outside of Sample">Coconut Cream Puffs </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch06#d0e1407" title="Link target outside of Sample">Choux à la Crème de Potiron et Canelle aux Pacanes </span>
</span>
</dt>
<dt>
<span class="bridgehead11">
<span href="#/ch06#d0e1409" title="Link target outside of Sample">Cinnamon-Spiced Pumpkin Pecan Cream Puffs </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch06#d0e1480" title="Link target outside of Sample">Recette Maîtresse pour la Crème Pâtissière </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch06#mastercream" title="Link target outside of Sample">Master Recipe for Pastry Cream </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch06#d0e1527" title="Link target outside of Sample">Chouquettes </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch06#d0e1529" title="Link target outside of Sample">Sugar-Crusted Cream Puffs </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch06#d0e1563" title="Link target outside of Sample">Choux à la Crème Pâtissière Sanguine avec Ganache et Sel
                  d'Erable </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch06#d0e1565" title="Link target outside of Sample">Cream Puffs with Blood Orange Pastry Cream, Chocolate
                  Cream and Maple Salt </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch06#d0e1625" title="Link target outside of Sample">Choux à la Crème Pâtissière des Amandes, Noix de Coco et
                  de Chocolat </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch06#d0e1627" title="Link target outside of Sample">Almond Joy Cream Puffs </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch06#d0e1679" title="Link target outside of Sample">Gros Choux à la Crème Pâtissière de Nutella et Café </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch06#d0e1681" title="Link target outside of Sample">Large Cream Puffs with Nutella and Coffee Pastry Cream
                </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch06#d0e1747" title="Link target outside of Sample">Choux à la Crème Pâtissière de Banane, Rhum,Cassonade et
                  Beurre </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch06#d0e1749" title="Link target outside of Sample">Bananas Foster Cream Puffs </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch06#creamsicle" title="Link target outside of Sample">Choux à la Crème d'Orange et Vanille </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch06#d0e1831" title="Link target outside of Sample">Creamsicle Cream Puffs </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch06#d0e1898" title="Link target outside of Sample">Choux à la Crème au Beurre au Café, Glaçage au Caramel
                </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch06#d0e1900" title="Link target outside of Sample">Cream Puffs with Coffee Buttercream and a Caramel Glaze
                </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch06#d0e1957" title="Link target outside of Sample">Gâteau St. Honoré </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch06#d0e1959" title="Link target outside of Sample">St. Honoré Cake </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch06#d0e2032" title="Link target outside of Sample">Croquembouche </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch06#d0e2034" title="Link target outside of Sample">Crunchy Choux Pyramid Cake </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch06#d0e2095" title="Link target outside of Sample">Paris-Brest </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch06#d0e2097" title="Link target outside of Sample">Choux Pastry with Praline-Flavored Cream </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch06#d0e2181" title="Link target outside of Sample">Profiteroles Classiques avec Glace à la Vanille et Sauce
                  au Chocolat Chaud </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch06#d0e2183" title="Link target outside of Sample">Classic Profiteroles with Vanilla Ice Cream and Hot
                  Chocolate Sauce </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch06#d0e2228" title="Link target outside of Sample">Profiteroles avec Glacé au Pistache et Sauce au Chocolat
                  Chaud </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch06#d0e2230" title="Link target outside of Sample">Profiteroles with Pistachio Ice Cream and Hot Chocolate
                  Sauce </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch06#macadamia" title="Link target outside of Sample">Profiteroles avec Glace de Caramel Salé aux Noix de
                  Macadamia et Sauce au Caramel Chaud </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch06#d0e2276" title="Link target outside of Sample">Profiteroles with Salted Caramel Macadamia Nut Ice Cream
                  and Warm Caramel Sauce </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch06#d0e2323" title="Link target outside of Sample">Beignets aux Coulis aux Framboises </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch06#d0e2325" title="Link target outside of Sample">Beignets with Raspberry Coulis </span>
</span>
</dt>
</dl>
</dd>
<dt>
<span class="chapter">
<span href="#/ch07" title="Link target outside of Sample">Sweet Éclairs </span>
</span>
</dt>
<dd>
<dl>
<dt>
<span class="bridgehead">
<span href="#/ch07#d0e2386" title="Link target outside of Sample">Petits Éclairs Comme “Cannoli” </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch07#d0e2388" title="Link target outside of Sample">Small “Cannoli” Éclairs </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch07#d0e2446" title="Link target outside of Sample">Gros Éclairs à la Crème de Myrtilles et Citron, Glaçage
                  au Chocolat </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch07#d0e2448" title="Link target outside of Sample">Large Éclairs with Lemon Blueberry Cream and Chocolate
                  Glaze </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch07#lime" title="Link target outside of Sample">Petits Éclairs à la Crème de Citron Vert et Chocolat Blanc
                </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch07#d0e2520" title="Link target outside of Sample">Small Éclairs with a Lime and White Chocolate Cream </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch07#smore" title="Link target outside of Sample">Gros Éclairs de Beurre de Cacahuètes, Pâte de Guimauve et
                  Chocolat </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch07#d0e2573" title="Link target outside of Sample">Gimme S’more Éclairs </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch07#d0e2620" title="Link target outside of Sample">Gros Éclairs à la Crème Pâtissière de Banane aux Noix de
                  Macadamia, Glaçage au Caramel </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch07#d0e2622" title="Link target outside of Sample">Large Éclairs with Banana Cream, Macadamia Nuts and
                  Caramel Glaze </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch07#d0e2667" title="Link target outside of Sample">Petits Éclairs à la Crème de Fraise Façon de “Shortcake”
                </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch07#d0e2669" title="Link target outside of Sample">Small Strawberry Cream “Shortcake” Éclairs </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch07#d0e2735" title="Link target outside of Sample">Gros Éclairs Exotiques à la Crème Pâtissière d’Mandarine
                  et Anana </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch07#d0e2737" title="Link target outside of Sample">Large Éclairs with an Exotic Mandarin Orange and
                  Pineapple Cream </span>
</span>
</dt>
</dl>
</dd>
<dt>
<span class="chapter">
<span href="#/ch08" title="Link target outside of Sample">Sweet Sauces </span>
</span>
</dt>
<dd>
<dl>
<dt>
<span class="bridgehead">
<span href="#/ch08#vanilla" title="Link target outside of Sample">Sauce Crème Sucrée au Vanille </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch08#d0e2818" title="Link target outside of Sample">Sweetened Vanilla Cream Sauce </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch08#ganache" title="Link target outside of Sample">Ganache </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch08#d0e2844" title="Link target outside of Sample">Hot Chocolate Sauce </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch08#anglaise" title="Link target outside of Sample">Crème Anglaise </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch08#d0e2875" title="Link target outside of Sample">Basic Vanilla Custard Sauce </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch08#raspberry" title="Link target outside of Sample">Coulis aux Framboises </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch08#d0e2919" title="Link target outside of Sample">Raspberry Sauce </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch08#caramel" title="Link target outside of Sample">Sauce au Caramel </span>
</span>
</dt>
<dt>
<span class="bridgehead1">
<span href="#/ch08#d0e2962" title="Link target outside of Sample">Caramel Sauce </span>
</span>
</dt>
</dl>
</dd>
<dt>
<span class="chapter">
<span href="#/ch09" title="Link target outside of Sample">Acknowledgments</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch10" title="Link target outside of Sample">Metric Conversion Chart</span>
</span>
</dt>
</dl>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bk01-toc.vue?2d79b444